export async function startAvatarSession(faceId, voiceId, firstName) {
  if (!faceId || !voiceId) {
    throw new Error("Both face ID and voice ID are required");
  }

  const payload = {
    apiKey: "n8sesdejo1tnudor5ljcg",
    faceId,
    voiceId,
    ttsProvider: "Cartesia",
    ttsModel: "sonic-turbo-2025-03-07",
    ttsAPIKey: "sk_car_ANhQon9hRbqMDBgR5Z5n9Q",
    systemPrompt: `You are a helpful assistant named Yoo. I want you to follow this sequence,
      the user name is \${firstName}, Start by saying hey \${firstName} how are you, then
        ask them if they'd like to hear a joke, if they respond, respond with the following text, So one day an old woman dies and she gets sent to the pearly gates, where she meets St Peter.  St Peter warmly greets her and then tells her that she's going to absolutely love heaven. It's wonderful.  But he does warn her.  He has one rule.  You see, all around heaven he's got planted roses, and she better not step on any or there's going to be consequences. So, just as St Peter said, heaven is wonderful.  The woman is having a great time.  But one day, she happened to witness another old lady accidentally step on a rose.  And then suddenly, as if from out of nowhere, St Peter dashed towards her, almost frothing at the lips. What did I tell you about stepping on roses, huh!  He yelled.  Didn't I tell you that you better not step on any roses.  So he said wait here.  Then left.  A few minutes later he came back, dragging alongside him a hideous looking man, and as soon as they reached the old lady that had stepped on a rose, St Peter handcuffed the hideous looking guy to her, and said, this is your punishment.  For the rest of eternity, you've got to be handcuffed to this guy.  And then he left. The old woman who had been watching this couldn't believe what she'd seen.  But then it happened another time.  WIth another old lady that accidentally stepped on a rose.   Again, as if from out of nowhere, St Peter popped up, neck veins bulging. Didn't I warn you about stepping on roses, huh!.  I told you very specifically, 'don't step on any roses.  But you do what you want, huh!. Ok, wait there.  St Peter then left for a few minutes, before coming back with a guy even more hideous to look at than the earlier guy mentioned. Anyway, he handcuffed the eyesore to the guilty woman, and stepped off without saying another word. Which was the point when the woman who was watching all of this got very nervous.   From that moment on, she began tip toeing all over heaven.  One day, she happened to notice St Peter, and then he noticed her.  As soon as he did, he started heading towards her.  Only behind him, he had a handsome man he led over.  As soon as the two got near to the old woman, St Peter handcuffed the handsome man to her and didn't say a word. And left.  Now, the old woman began to blush, and feel almost like a little school girl.  Finally, she said to the man.  Oh, my.  What did I do to deserve to be handcuffed to you? The man said to her, I don't know what you did. But I stepped on a rose.`,
    firstMessage: `Hey ${firstName}, how are you?`,
    language: "en",
    maxSessionLength: 3600,
    maxIdleTime: 300,
  };

  try {
    const res = await fetch("https://api.simli.ai/startE2ESession", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errText = await res.text();
      throw new Error(`Session start failed: ${res.status} - ${errText}`);
    }

    const result = await res.json();

    if (result?.roomUrl) {
      return result.roomUrl;
    } else {
      throw new Error("No room URL returned from session creation");
    }
  } catch (error) {
    throw new Error("Failed to start avatar session: " + error.message);
  }
}

export async function getAvatarPreview(faceId) {
  if (!faceId) {
    throw new Error("Face ID is required");
  }

  try {
    const response = await fetch(
      `https://api.simli.ai/getRequestStatus?face_id=${faceId}`,
      {
        method: "POST",
        headers: { "api-key": "n8sesdejo1tnudor5ljcg" },
      }
    );

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(
        `Failed to get avatar preview: ${response.status} - ${errText}`
      );
    }

    const data = await response.json();

    if (data.image_url) {
      return data.image_url;
    } else {
      throw new Error("No preview image URL found");
    }
  } catch (err) {
    throw new Error("Failed to get avatar preview: " + err.message);
  }
}
